import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class HelperService {

  constructor(private domSanitizer: DomSanitizer) { }

  base64Image(image: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(image);
  }
}
